import { format, addMonths, startOfDay } from "date-fns";
import { useEffect, useState } from "react";
import BookingModel from "../../model/BookingModel";
import DestinationModel from "../../model/DestinationModel";
import WaitingTimeModel from "../../model/WaitingTimeModel";

export default function Destination({ formData, setFormData, validationErrors }) {
  const [destinationData, setDestinationData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [slabs, setSlabs] = useState([]);

  const today = startOfDay(new Date());
  const twoMonthsFromNow = addMonths(today, 2);

  useEffect(() => {
    setDestinationData(DestinationModel.getDestinations())
  }, []);


  useEffect(() => {
    const slabs = WaitingTimeModel.getAllWaitSlabs();
    setSlabs(slabs)

  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === 'adjustDistance') {
      const kmValue = parseFloat(value);
      if (kmValue < -10 || kmValue > 99) {
        alert("Additional Km must be between -10 and 99.");
        return;
      }
    }

    if (name === 'waitMinute') {
      const minuteValue = parseInt(value, 10);
      if (minuteValue < 0 || minuteValue > 815) {
        alert("Waiting Minute must be between 0 and 815.");
        return;
      }
    }

    // When destination is changed, ensure it matches a known destination.
    // If it does, update the corresponding trip distance; otherwise clear it.
    if (name === 'destination') {
      const destination = destinationData.find(
        (item) => item.name.trim().toLowerCase() === value.trim().toLowerCase()
      );

      if (destination) {
        const correspondingDistance = destination.distance;
        setFormData((prevState) => ({
          ...prevState,
          [name]: value,
          tripDistance: correspondingDistance,
        }));
        BookingModel.tripDistance = correspondingDistance;
      } else {
        setFormData((prevState) => ({
          ...prevState,
          [name]: value,
          tripDistance: 0,
        }));
        BookingModel.tripDistance = 0;
        return;
      }
    }
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };


  const openModal = (type) => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);

  };

  return (
    <div className="booking-step-destination">
      <span className="heading">
        Select destination details
      </span>
      <div className="inner-box">
        <div className="left">
          <div className="form-controller">
            <label>Terminal</label>
            <select
              className={`input ${validationErrors.standCounter ? "input-error" : ""}`}
              name="standCounter"
              id="standCounter"
              value={formData.standCounter}
              onChange={handleChange}
            >
              <option value="">Select Terminal</option>
              <option value="International">International</option>
              <option value="Domestic">Domestic</option>
            </select>
          </div>

          <div className="form-controller">
            <div><i className='fa-solid fa-exclamation'></i></div>
            <div>
              Select <span>destination</span> from the list only, if your desired location is not available, please select the nearest
              <span>destination</span> to your area and enter <span>additional kilometer</span> to your place from the selected destination.
            </div>
          </div>
          <div className="form-controller">
            <label>Destination</label>
            <input className={validationErrors.destination ? "input-error" : ""} list="destinationOptions" value={formData.destination || ''} onChange={handleChange} name="destination" id="destination" placeholder="Enter Your Destination" />
            <datalist id="destinationOptions">
              {destinationData.map((dest, index) => (
                <option
                  key={index}
                  value={dest.name}
                />
              ))}
            </datalist>
          </div>
        </div>
        <div className="right">
          <div className="form-controller">
            <label>Trip Date</label>
            <input id="tripDate"
              type="date"
              required
              className={validationErrors.tripDate ? "input-error" : ""}
              min={format(today, "yyyy-MM-dd")}
              max={format(twoMonthsFromNow, "yyyy-MM-dd")}
              value={formData.tripDate || ""}
              onChange={(e) => {
                const selectedDate = e.target.value
                  ? format(new Date(e.target.value), "yyyy-MM-dd")
                  : null;

                setFormData((prevState) => ({
                  ...prevState,
                  tripDate: selectedDate,
                }));
              }} />
          </div>
          <div className="form-controller">
            <label>Additional Distance</label>
            <input type="number" name="adjustDistance" id="adjustDistance" placeholder="Additional Kilometers (if any)"
              autoComplete="off"
              className={validationErrors.adjustDistance ? "input-error" : ""}
              value={formData.adjustDistance}
              onChange={handleChange} />
          </div>
          <div className="form-controller">
            <label>Waiting Time</label>
            <input type="number" name="waitMinute" id="waitMinute" placeholder="Waiting Time in Minitues (if any)"
              autoComplete="off"
              className={validationErrors.waitMinute ? "input-error" : ""}
              value={formData.waitMinute}
              onChange={handleChange} />
            <span className="suffix">
              <i onClick={openModal} className="fa fa-exclamation-circle" aria-hidden="true"></i>
            </span>
          </div>
        </div>
      </div>
      {isModalOpen && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <span className="modal-close" onClick={closeModal}>
              &times;
            </span>
            <h2>Waiting Time Slabs</h2>
            <table className="slab-table">
              <thead>
                <tr>
                  <th>SL.NO</th>
                  <th>From (min)</th>
                  <th>To (min)</th>
                  <th>Charge</th>
                </tr>
              </thead>
              <tbody>
                {slabs.map((slab, key) => (
                  <tr
                    key={key}
                    className="clickable-row"
                    onClick={() => {
                      setFormData(prevData => ({
                        ...prevData,
                        waitMinute: slab.waitTo
                      }));

                      setIsModalOpen(false);
                    }}
                  >
                    <td>{key + 1}</td>
                    <td>{slab.waitFrom} ({slab.waitFromFormatted})</td>
                    <td>{slab.waitTo} ({slab.waitToFormatted})</td>
                    <td> <span className='rupee-symbol'>₹</span> {slab.chargePerMnt}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  )
}
